import { type ActionEvent, Controller } from "@hotwired/stimulus"

import CarouselController from "@/controllers/carousel_controller"
import { isSmallPalm } from "@/helpers/window_size"

export default class VenueCarouselController extends Controller {
  static outlets = ["carousel"]
  declare readonly carouselOutlet: CarouselController

  slideTo(event: ActionEvent): void {
    this.carouselOutlet.slideTo(event)
  }

  unhideMobileSlides(): void {
    // Carousel slides are hidden by default, but venue carousel is vertically scrollable on mobile
    // which won't work unless they're visible. Unhide them on first click.
    if (isSmallPalm()) {
      this.carouselOutlet.slideListItemTargets.forEach((slide) => (slide.hidden = false))
    }
  }
}
